/**
 * Maps the Slot Selection Email step's form values to the API request shape.
 *
 * Backend permit list keys (ats_schedules_helper.rb):
 *   candidate_mail_subject, candidate_mail_body, candidate_mail_from,
 *   candidate_mail_cc, candidate_mail_bcc, candidate_mail_attachments,
 *   candidate_mail_template_id, candidate_mail_updated
 *
 * Only used for self-schedule modes — manual/adhoc have no slot selection email.
 */
export function mapSlotEmailToApi(
  slotSelectionEmail: Record<string, unknown> | undefined
): Record<string, unknown> {
  if (!slotSelectionEmail || typeof slotSelectionEmail !== 'object') return {};
  const src = slotSelectionEmail as Record<string, unknown>;
  const out: Record<string, unknown> = {};

  if (typeof src.subject === 'string' && src.subject.length > 0) {
    out.candidate_mail_subject = src.subject;
  }
  if (typeof src.body === 'string' && src.body.length > 0) {
    out.candidate_mail_body = src.body;
  }
  if (src.from_organizer === true) {
    out.candidate_mail_from = null;
  } else if (typeof src.from === 'number' && Number.isFinite(src.from)) {
    out.candidate_mail_from = src.from;
  }
  if (Array.isArray(src.cc) && src.cc.length > 0) {
    out.candidate_mail_cc = src.cc;
  }
  if (Array.isArray(src.bcc) && src.bcc.length > 0) {
    out.candidate_mail_bcc = src.bcc;
  }
  if (Array.isArray(src.attachments) && src.attachments.length > 0) {
    out.candidate_mail_attachments = src.attachments;
  }
  if (src._ui_template_id !== null && src._ui_template_id !== undefined) {
    out.candidate_mail_template_id = src._ui_template_id;
  }
  // Flag that the mail was touched this save — mirrors legacy
  // `candidate_mail_updated: hasEmailDataChanged()`.
  out.candidate_mail_updated = true;

  return out;
}
